import React, { useState, useEffect } from 'react';
import styles from './SearchBar.module.css';

const SearchBar = ({ 
  placeholder, 
  onSearchChange, 
  onFocus, 
  onBlur, 
  value: controlledValue 
}) => {
  const [internalValue, setInternalValue] = useState('');

  // Use controlled value if provided, otherwise use internal state
  const displayValue = controlledValue !== undefined ? controlledValue : internalValue;

  // Update internal value when controlled value changes
  useEffect(() => {
    if (controlledValue !== undefined) {
      setInternalValue(controlledValue);
    }
  }, [controlledValue]);

  const handleChange = (e) => {
    const newQuery = e.target.value;
    
    // Update internal state if not controlled
    if (controlledValue === undefined) {
      setInternalValue(newQuery);
    }
    
    if (onSearchChange) {
      onSearchChange(newQuery);
    }
  };

  const handleFocus = (e) => {
    if (onFocus) {
      onFocus(e);
    }
  };

  const handleBlur = (e) => {
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <div className={styles.searchBar}>
      <svg 
        className={styles.searchIcon} 
        width="16" 
        height="16" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M21 21L15.514 15.514M18 10.5C18 14.6421 14.6421 18 10.5 18C6.35786 18 3 14.6421 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5Z" 
          stroke="#9CA3AF" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
      <input
        type="text"
        value={displayValue}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder || 'Search...'}
        className={styles.searchInput}
      />
    </div>
  );
};

export default SearchBar; 